import {
  Box,
  Checkbox,
  FormControlLabel,
  Link,
  Typography,
} from "@mui/material";
import React, { useState } from "react";

import LoadingButton from "../../../components/MUI/LoadingButton";
import { SERVER_URL } from "../../../config";

type SignatureDisclosureProps = {
  loading: boolean;
  onSubmit: () => void;
};

const SignatureDisclosure = (props: SignatureDisclosureProps) => {
  const { loading, onSubmit } = props;
  const [isChecked, setIsChecked] = useState<boolean>(false);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked);
  };

  const handleContinue = () => {
    if (isChecked) {
      onSubmit();
    }
  };

  return (
    <Box
      sx={{
        paddingX: 2,
        height: "100%",
        display: "flex",
        alignSelf: "center",
        width: "fit-content",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          padding: 4,
          background: "white",
          borderRadius: "8px",
        }}
      >
        <Typography sx={{ fontSize: 18, mb: 1 }}>
          Please read the{" "}
          <Link target="_blank" href={`${SERVER_URL}/conditions/signatures`}>
            Electronic Record and Signature Disclosure.
          </Link>
        </Typography>
        <FormControlLabel
          sx={{ margin: 0 }}
          control={
            <Checkbox
              sx={{ borderRadius: 0, padding: 0, mr: 1 }}
              checked={isChecked}
              onChange={handleCheckboxChange}
            />
          }
          label="Before signing, I agree to use electronic records and signatures"
        />
      </Box>
      {isChecked && (
        <LoadingButton
          size="large"
          loading={loading}
          variant="contained"
          onClick={handleContinue}
          sx={{ mt: 2, px: 3, alignSelf: "center" }}
        >
          Continue
        </LoadingButton>
      )}
    </Box>
  );
};

export default SignatureDisclosure;
